<wsd-extended-card
  [loading]="!(gsat$ | async)"
  [title]="'DATA_PORTAL.GLOBAL_SUPPORT.TITLE' | translate">
  <div class="text-center" *ngIf="gsat$ | async as data">
    <div class="p-grid">
      <div class="p-col-4 p-relative">
        <a *ngIf="data.assessmentResults?.SELF_ASSESSMENT.assessmentResults > 0; else withoutSelfLink"
           [href]="assessmentResults + '&typeId='+ data.assessmentResults.SELF_ASSESSMENT.assessmentType + '&versId=' + data.assessmentResults.SELF_ASSESSMENT.assessmentVersion"
           target="_blank">
          <wsd-radial-progress
            [progress]="data.assessmentResults?.SELF_ASSESSMENT.assessmentResults"
            [description]="data.assessmentResults?.SELF_ASSESSMENT.date | date: 'dd.MM.yyyy'">
          </wsd-radial-progress>
        </a>
        <ng-template #withoutSelfLink>
          <wsd-radial-progress
            [progress]="data.assessmentResults?.SELF_ASSESSMENT.assessmentResults"
            [description]="data.assessmentResults?.SELF_ASSESSMENT.date | date: 'dd.MM.yyyy'">
          </wsd-radial-progress>
        </ng-template>
        <label class="m-t-5">
          {{'DATA_PORTAL.GLOBAL_SUPPORT.SELF_ASSESSMENT' | translate}}
        </label>
      </div>

      <div class="p-col-4 p-relative">
        <a *ngIf="data.assessmentResults?.WOSM_ASSESSMENT.assessmentResults > 0; else withoutWosmLink"
           [href]="assessmentResults + '&typeId='+ data.assessmentResults.WOSM_ASSESSMENT.assessmentType + '&versId=' + data.assessmentResults.WOSM_ASSESSMENT.assessmentVersion"
           target="_blank">
          <wsd-radial-progress
            [progress]="data.assessmentResults?.WOSM_ASSESSMENT.assessmentResults"
            [description]="data.assessmentResults?.WOSM_ASSESSMENT.date | date: 'dd.MM.yyyy'">
          </wsd-radial-progress>
        </a>
        <ng-template #withoutWosmLink>
          <wsd-radial-progress
            [progress]="data.assessmentResults?.WOSM_ASSESSMENT.assessmentResults"
            [description]="data.assessmentResults?.WOSM_ASSESSMENT.date | date: 'dd.MM.yyyy'">
          </wsd-radial-progress>
        </ng-template>
        <label class="m-t-5">
          {{'DATA_PORTAL.GLOBAL_SUPPORT.WOSM_ASSESSMENT' | translate}}
        </label>
      </div>

      <div class="p-col-4 p-relative">
        <a *ngIf="data.assessmentResults?.THIRD_PARTY_ASSESSMENT.assessmentResults > 0; else withoutThirdLink"
           [href]="assessmentResults + '&typeId='+ data.assessmentResults.THIRD_PARTY_ASSESSMENT.assessmentType + '&versId=' + data.assessmentResults.THIRD_PARTY_ASSESSMENT.assessmentVersion"
           target="_blank">
          <wsd-radial-progress
            [progress]="data.assessmentResults?.THIRD_PARTY_ASSESSMENT.assessmentResults"
            [description]="data.assessmentResults?.THIRD_PARTY_ASSESSMENT.date | date: 'dd.MM.yyyy'">
          </wsd-radial-progress>
        </a>
        <ng-template #withoutThirdLink>
          <wsd-radial-progress
            [progress]="data.assessmentResults?.THIRD_PARTY_ASSESSMENT.assessmentResults"
            [description]="data.assessmentResults?.THIRD_PARTY_ASSESSMENT.date | date: 'dd.MM.yyyy'">
          </wsd-radial-progress>
        </ng-template>
        <label class="m-t-5">
          {{'DATA_PORTAL.GLOBAL_SUPPORT.THIRD_PARTY_ASSESSMENT' | translate}}
        </label>
      </div>

    </div>
  </div>
</wsd-extended-card>
